<template>
  <section v-on:click="sectionClicked">
    <div class="notFound" v-if="!page || !page.page || !page.page.sectionData
      || page.page.sectionData.length < 1"></div>
    <template v-else>
      <section class="section" v-for="(sc, i) in page.page.sectionData" :key="`p${i}`">
        <a :href="`/${langCode}/cop29`" class="icel-cop-29" v-if="sc.id === 'stories-impact' && 1>2">
          <div class="cnt">
            <h3>ICEL AT COP29</h3>
            <a :href="`/${langCode}/cop29`">
              <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-move-right">
                <defs>
                  <filter id="drop-shadow" x="-50%" y="-50%" width="200%" height="200%">
                    <feDropShadow dx="5" dy="5" stdDeviation="5" flood-color="black" flood-opacity="0.5" />
                  </filter>
                </defs>
                <path d="M18 8L22 12L18 16" filter="url(#drop-shadow)"/><path d="M2 12H22"/>
              </svg>
            </a>
          </div>
        </a>
        <Slider v-if="sc.type === 'Slider'" :section="sc"></Slider>
        <ImageHeader v-else-if="sc.type === 'Image Header'"
          :section="sc" :style="{'background-color': sc.color}"></ImageHeader>
        <LeftImage v-else-if="['Left Image', 'Right Image'].includes(sc.type)"
          :section="sc" :style="{'background-color': sc.color}"></LeftImage>
        <BlockArticles v-else-if="sc.type === 'Block Articles'"
          :section="sc" :page="page.page" :style="{'background-color': sc.color}"></BlockArticles>
        <IconSlider v-else-if="sc.type === 'Icon Slider'"
          :section="sc" :style="{'background-color': sc.color}"></IconSlider>
        <TextBlock v-else-if="sc.type === 'Text Block'"
          :section="sc" :style="{'background-color': sc.color}"></TextBlock>
        <Gallery v-else-if="sc.type === 'Gallery'"
          :section="sc" :style="{'background-color': sc.color}"></Gallery>
        <Subscription v-else-if="sc.type === 'Subscription'"
          :section="sc" :style="{'background-color': sc.color}"></Subscription>
        <CustomBlock v-else-if="sc.type === 'Custom Block'"
          :section="sc" :style="{'background-color': sc.color}"></CustomBlock>
        <Map v-else-if="sc.type === 'Map'"
          :section="sc" :style="{'background-color': sc.color}"></Map>
        <Form v-else-if="sc.type === 'Form'"
          :section="sc" :style="{'background-color': sc.color}"></Form>
      </section>
    </template>
  </section>
</template>

<script>
import Slider from '@/components/Section/Slider.vue';
import LeftImage from '@/components/Section/LeftImage.vue';
import ImageHeader from '@/components/Section/ImageHeader.vue';
import BlockArticles from '@/components/Section/BlockArticles.vue';
import IconSlider from '@/components/Section/IconSlider.vue';
import Gallery from '@/components/Section/Gallery.vue';
import Subscription from '@/components/Section/Subscription.vue';
import Map from '@/components/Section/Map.vue';
import Form from '@/components/Section/Form.vue';
import TextBlock from '@/components/Section/TextBlock.vue';
import CustomBlock from '@/components/Section/CustomBlock.vue';

export default {
  name: 'home',
  props: ['page', 'breadcrumb'],
  components: {
    Slider,
    LeftImage,
    ImageHeader,
    BlockArticles,
    IconSlider,
    Gallery,
    Subscription,
    Map,
    Form,
    TextBlock,
    CustomBlock,
  },
  data() {
    return {
      ch: null,
      loading: true,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.icel-cop-29{
  display: block;
  background-image: url(../assets/icel-cop29-bg.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  .cnt{
    padding: 50px 0;
    position: relative;
    @media (max-width: 768px) {
      padding: 36px 0;
    }
    h3{
      font-size: 120px;
      line-height: 0;
      color: #fff;
      text-shadow: 4px 4px 12px rgba($color: #000000, $alpha: .4);
      @media (max-width: 1024px) {
        font-size: 80px;
      }
      @media (max-width: 768px) {
        font-size: 36px;
      }
    }
    a{
      position: absolute;
      right: 0; bottom: 10px;
      color: #fff;
      @media (max-width: 768px) {
        right: -20px;
      }
      svg{
        @media (max-width: 1024px) {
          height: 40px;
        }
        @media (max-width: 768px) {
          height: 30px;
        }
      }
    }
  }
}
</style>
